import 'zone.js/dist/zone-error';

export const environment = {
  production: false,
  environmentName: 'production',
  // baseUrl: 'https://api.v7.botpenguin.com/',
  baseUrl: 'https://api-1.botpenguin.ai/',
  // baseUrl: 'https://rajan.api-dev-v2.botpenguin.us/',
  facebookCdnUrl: 'https://dev-botpenguin.s3.us-east-2.amazonaws.com/tools',
  preview: 'cdn.js',
  botScript: 'cdn.js',
  // cdnUrl: 'https://dev-botpenguin.s3.us-east-2.amazonaws.com/',
  cdnUrl: 'https://launcher.botpenguin.us/',
  // domain: 'https://api-dev.botpenugin.us/',
  domain: 'http://api-1.botpenguin.ai.local/',
  profileId: 122,
  razorpay: 'rzp_test_bPDQkFo1rmCe3w',
  stripe: 'pk_test_GoVB6wxLsfTW9aTHPi50dkOq00FiMuWbkV',
  giphy: 'A7zgGwm71lsBSK5ED6cKTZoG6T0fTZnL',
  embedded: 'https://window.botpenguin.us',
  // socket: 'https://api-dev.botpenugin.us/',
  socket: 'https://api-1.botpenguin.ai/',
  // socket: 'http://192.168.1.91:4000/',
  // landingPage: 'https://page.botpenguin.com/',
  landingPage: 'http://192.168.1.155:3001/',
  googleClientId: '593742482865-t7ln3krn11dms37tif7fqfc5tktb9969.apps.googleusercontent.com',
  logo: '//cdn.botpenguin.com/assets/logos/botpenguin-logo.png',
  appName: 'BotPenguin',
  privacyPolicyUrl: 'https://botpenguin.com/privacy-policy',
  websiteUrl: 'https://botpenguin.com',
  favicon: 'favicon.ico',
  rootAgencyId: '614c81464774d71b1fad621f',
  chatWindowUrl: 'https://window-new.botpenguin.com',
  // chatWindowUrl: 'https://dev-botpenguin.s3.us-east-2.amazonaws.com/messenger',
  toolsUrl: 'https://dev-botpenguin.s3.us-east-2.amazonaws.com/tools',
  telegramWidgetFile: 'widget.js',
  whatsAppWidgetFile: 'whatsapp-widget.js',
  zohoClientId: '1000.JSJAGKT9SZ78EBIEOMNZTRI3SDASRQ',
  zohoDeskRedirectURL: 'https://app-1.botpenguin.ai/zoho-desk.html',
  zohoCrmRedirectURL: 'https://app-1.botpenguin.ai/zoho-crm.html',
  zohoProjectsRedirectURL: 'https://app-1.botpenguin.ai/zoho-projects.html',
  canvasUrl: 'https://canvas-1.botpenguin.ai',
  // canvasUrl: 'https://canvas.botpenguin.com',
  oldVersion: 'https://classic.app.botpenguin.com',
  newVersion: 'https://app.botpenguin.com',
  liveChatBotId: '5fed62fbb3053e15ba12c0de',
  leadGenerationBotId: '5fed62fbb3053e15ba12c4a1',
  outlookRedirectUrl: 'https://app-1.botpenguin.ai/outlook.html',
  ipDetailsUrl: 'https://api.botpenguin.com/meta/ip',
  salesForceRedirectUrl: 'https://app-1.botpenguin.ai/salesforce-crm.html',
  rootAgencyDomain: ['app-1.botpenguin.ai', 'www.app-1.botpenguin.ai'],
  recaptchaSiteKey: '6Le6zeYkAAAAAJ4RJn0X0Gpe5bGIwBoo34Oqi4eM',
  graphUrl: 'https://graph.facebook.com/v16.0/',
  servingDomain: 'https://app-1.botpenguin.ai',
  help: {
    productUpdates: 'https://help.botpenguin.com/product-updates/whats-new',
    requestFeature: 'https://page.botpenguin.com/632b02e3d955092f0582f320/5fed38346fb193dcc6c92d65',
    reportBug: 'https://page.botpenguin.com/632b09b7d955092f0582f952/5fed38346fb193dcc6c92d65',
    productRoadmap: 'https://botpenguin.notion.site/botpenguin/07030e5110894c19bdf5583d6fc7f773?v=8a612ba08cbd4a198e1c9db89813cb23'
  },
  instagramTestUserId: '648c64fb34e5b23a4463205a',
  demoBotNumber: '15550154880',
  conversationalBot: 'http://192.168.1.88:4203/',
  createBotPenguin: 'http://192.168.1.88:4202/',
  stripePublicKey: 'pk_test_sfBX8Xc4DCFAIEXu575HqT3q',
  embeddedBot: 'https://messenger.botpenguin.com/',
  raiseTicketUrl: 'https://page.botpenguin.com/632b09b7d955092f0582f952/5fed38346fb193dcc6c92d65',
  whatsAppEmbeddedOnboarding: 'https://cdn.botpenguin.com/bp-htmls/wa-signup.html',
  encryptionKey: 'botpenguin',
};
